"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GenericErrorState_1 = require("./GenericErrorState");
/** Platform UI Components */
var GridRow_1 = require("@idp/ui-components/components/containers/Grid/GridRow");
var GridColumn_1 = require("@idp/ui-components/components/containers/Grid/GridColumn");
// import { NoWirelessAccountCms } from './NoWirelessAccount.cms';
/** Stylesheets */
var utilityStyles = require("../../../styles/utilities.scss");
var appStyles = require("../../../styles/login-widget.scss");
var styles = require("./GenericError.scss");
/** LOB Components */
var PageLevelHeading_1 = require("../../common/PageLevelHeading");
var PageLevelHeadingProps_1 = require("../../common/PageLevelHeading/PageLevelHeadingProps");
var CtaButtonGroup_1 = require("../../common/CtaButtonGroup");
var CtaButtonGroupProps_1 = require("../../common/CtaButtonGroup/CtaButtonGroupProps");
/** Api, Reporting, Mappers, Request, Response */
var CommonFunctions_1 = require("../../common/CommonFunctions/CommonFunctions");
var LoginConfiguration_1 = require("../../../services/LoginConfiguration");
var GenericError = /** @class */ (function (_super) {
    __extends(GenericError, _super);
    function GenericError(props) {
        var _this = _super.call(this, props) || this;
        _this.commonFunctions = null;
        _this.state = new GenericErrorState_1.default();
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        _this.continueBtnEvents = _this.continueBtnEvents.bind(_this);
        return _this;
    }
    GenericError.prototype.continueBtnEvents = function () {
        // console.log( 'Continue Event Clicked.' );
        // this.reportingService.fireLinkClickEvent('Continue', PageUrls.NO_WLS_ACCOUNT_PAGE);
        var appId = null;
        try {
            if (window.location.pathname.startsWith('/acctmgmt')) {
                appId = this.commonFunctions.isTestEnv() ?
                    LoginConfiguration_1.default.haloCServicesMechIdTest
                    : LoginConfiguration_1.default.haloCServicesMechIdProd;
            }
        }
        catch (error) {
            console.error('set default appid for logout.');
        }
        var gotoUrl = this.commonFunctions.getHaloCLogoutUrlForEnv()
            + encodeURIComponent(this.commonFunctions.createHalocUrl('false', appId));
        window.location.href = gotoUrl;
    };
    GenericError.prototype.render = function () {
        var loginGenericErrorTestId = 'Login_Generic_Error';
        return (React.createElement("div", { className: [styles.loginGenericErrorWrapper].join(' ') },
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: { size: 12, className: 'no-pad', customOptions: '' } },
                    React.createElement("div", { className: [utilityStyles.formRow].join(' ') },
                        React.createElement(PageLevelHeading_1.default, { data: {
                                headingText: 'Oops! Something isn\'t working quite right.',
                            }, options: {
                                type: PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON,
                            }, testId: loginGenericErrorTestId + '_Header' })))),
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: {
                        size: 7,
                        className: appStyles.innerPanelContainer + ' pad-none',
                        customOptions: '',
                    } },
                    React.createElement("div", { className: [
                            utilityStyles.marTXxs,
                            utilityStyles.padTXxxs,
                            styles.signedInWith,
                        ].join(' ') },
                        React.createElement("span", null, 'Try signing out, then sign back in and try again.')),
                    React.createElement("div", { className: [
                            utilityStyles.marTMdLg,
                        ].join(' ') },
                        React.createElement(CtaButtonGroup_1.default, { data: {
                                primaryBtnText: 'Sign Out',
                            }, options: {
                                type: CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_LEFT,
                            }, primaryBtnEvents: {
                                onClick: this.continueBtnEvents,
                            } }))))));
    };
    return GenericError;
}(React.Component));
exports.default = GenericError;
//# sourceMappingURL=GenericError.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/GenericError/GenericError.js
// module id = 661
// module chunks = 8